require('styles/blocks/identificationCard/_identification-card.scss');

const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const ibanIcon = require('assets/icons/headline/iban-desktop.svg');
const correosIcon = require('assets/icons/headline/correos-mobile.svg');
const documentacionIcon = require('assets/icons/headline/documentos-desktop.svg');
const transferIcon = require('assets/icons/identity/icon-transfer.svg');
const videoCallIcon = require('assets/icons/icon-camara_on.svg');

const IdentificationCard = ({ children, className, iconClassName, contentClassName, icon }) => {
    const availableIcons = {
        iban: ibanIcon,
        correos: correosIcon,
        documentacion: documentacionIcon,
        videocall: videoCallIcon,
        transfer: transferIcon,
    };

    const qtyChildren = React.Children.count(children);

    return (
        <div className={`identification-card ${className}`}>
            <div className={`identification-card-icon ${iconClassName}`}>
                <img src={availableIcons[icon]} alt="" />
            </div>
            <div
                className={classNames(`identification-card-content ${contentClassName}`, {
                    'identification-card-content--centered': qtyChildren <= 1,
                })}
            >
                {children}
            </div>
        </div>
    );
};

IdentificationCard.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    iconClassName: PropTypes.string,
    contentClassName: PropTypes.string,
    icon: PropTypes.oneOf(['iban', 'correos', 'documentacion']).isRequired,
};

module.exports.constructor = IdentificationCard;
module.exports = IdentificationCard;
